import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "pme-mobile-dropdown",
    templateUrl: "./mobile-dropdown.component.html",
    styleUrls: ["./mobile-dropdown.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class MobileDropdownComponent implements OnInit {
    @Output() onToggle = new EventEmitter<boolean>();
    @Input() mobileWidth: number = 830;
    
    onMobile: boolean;
    accordionExpanded: boolean;
    
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        let innerWidth = event.target.innerWidth;
        this.onMobile = innerWidth <= this.mobileWidth;
    }
    
    ngOnInit(): void {
        this.onMobile = window.innerWidth <= this.mobileWidth;
    }

    handleToggle(e: boolean) {
        this.accordionExpanded = e;
        this.onToggle.emit(e);
    }
}